export const getAuthIsPosting = state => state.authReducer.isPosting;
export const getAuthPostSuccess = state => state.authReducer.postSuccess;
export const getAuthError = state => state.authReducer.error;

export const getValidateGuidIsFetching = state => state.authReducer.validateGuidIsFetching;
export const getValidateGuidSuccess = state => state.authReducer.validateGuidSuccess;

export const getSingleLoggedInUser = state => state.authReducer.user;
export const getAuthIsFetching = state => state.authReducer.isFetching;
